<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div v-if="Object.keys(userData).length">
        <div class="d-sm-flex d-none user-nav justify-content-start">
          <p class="user-name font-weight-bolder mb-0">
            {{ userData.first_name + " " + userData.last_name }}
          </p>
          <span class="user-status w-100 px-1">{{ "کاربر" }}</span>
        </div>
        <b-avatar
          size="40"
          :src="userData.avatar"
          variant="light-primary"
          badge
          class="badge-minimal"
          badge-variant="success"
        >
          <feather-icon v-if="!userData.first_name" icon="UserIcon" size="22" />
        </b-avatar>
      </div>
      <div v-else>
        <b-link
          class="font-weight-bolder user-name"
          :to="{ name: 'auth-login' }"
        >
          ورود/ثبت نام
          <feather-icon icon="UserIcon" size="22" />
        </b-link>
      </div>
    </template>

    <b-dropdown-item
      v-if="Object.keys(userData).length"
      :to="{ name: 'profile-road-map' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="UserIcon" class="mr-50" />
      <span>پروفایل</span>
    </b-dropdown-item>

    <b-dropdown-divider />
    <b-dropdown-item
      v-if="tempUser"
      @click="backtoAdminMode"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="RefreshCcwIcon" class="mr-50" />
      <span>برگشت به حالت ادمین</span>
    </b-dropdown-item>

    <b-dropdown-divider v-if="tempUser" />
    <b-dropdown-item
      v-if="Object.keys(userData).length"
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
      <span>خروج</span>
    </b-dropdown-item></b-nav-item-dropdown
  >
</template>

<script>
import {
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
  BLink,
} from "bootstrap-vue";
import { avatarText } from "@core/utils/filter";

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BLink,
  },
  data() {
    return {
      avatarText,
      tempUser: localStorage.getItem("tempUserData"),
    };
  },
  computed: {
    userData() {
      return this.$store.state.auth.userData || {};
    },
  },

  methods: {
    async backtoAdminMode() {
      localStorage.removeItem("tempUserData");
      localStorage.removeItem("user_token");

      const token = await JSON.parse(localStorage.getItem("token"));
      if (token)
        this.$http.defaults.headers.common["Authorization"] =
          await `${token.type} ${token.val}`;
      window.location.replace("/users");
    },
    async logout() {
      // Remove userData from localStorage
      try {
        const { data } = await this.$http.post("/panel/auth/logout");
        localStorage.removeItem("userData");
        localStorage.removeItem("tempUserData");
        localStorage.removeItem("user_token");
        this.$store.dispatch("auth/setUserData", {});
        localStorage.removeItem("token");
        this.$http.defaults.headers.common["Authorization"] = ``;
        // Redirect to login page
        this.$store.commit("appConfig/UPDATE_NAV_MENU_HIDDEN", true);
        this.$router.push({ name: "auth-login" });
      } catch (err) {}
    },
  },
};
</script>
